
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(5(13|14|79)|(06|40|77)4|(01|17|47)9|272|988)|2(8(03|40|47|63)|055|133|354|43|549|572|65)|5(9(17|63|66)|5(32|83|85)|3(19|78|95)|6(35|37|4|91)|100|14|469|883)|6(4(07|19|24)|106|151|29|683|732)|1(8(86|87|91)|7(15|33|89)|3(59|66|79)|177|224|405|484|597|969)|8(43[03]|15[24]|025|250|361|526|624|862|907)|7(7(88|9|93)|48[89]|(07|20|58|65)3|096|232|325|38)|3(7(09|21|25)|(|9)43|104|311|37|85|879|92)|9(7(10|36|89)|(|5)31|(34|45|56)7|064|282|614|665|815))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
